// extracted by mini-css-extract-plugin
export default {"form":"ChangePasswordForm_form__-E3Yi","content":"ChangePasswordForm_content__hXZRF","inset":"ChangePasswordForm_inset__Pi2Ql"};